(function () {
  function addReveal(elements, variant, step) {
    elements.forEach(function (element, index) {
      element.classList.add('igari-reveal');
      if (variant) element.classList.add('igari-reveal--' + variant);
      element.style.setProperty('--igari-reveal-delay', String(Math.min(index * (step || 70), 280)) + 'ms');
    });
  }

  function initIgariMotion(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.igari--motion:not([data-igari-motion-ready])').forEach(function (article) {
      article.setAttribute('data-igari-motion-ready', 'true');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      addReveal(article.querySelectorAll('.igari-hero__copy > *'), '', 90);
      addReveal(article.querySelectorAll('.igari-hero__portrait'), 'scale', 0);
      addReveal(article.querySelectorAll('.igari-intro__heading, .igari-intro__profile'), '', 90);
      addReveal(article.querySelectorAll('.igari-section-heading'), '', 0);
      addReveal(article.querySelectorAll('.igari-movie'), 'scale', 90);
      addReveal(article.querySelectorAll('.igari-product__number, .igari-product__title'), '', 70);
      addReveal(article.querySelectorAll('.igari-product__shot'), 'scale', 100);
      addReveal(article.querySelectorAll('.igari-quote'), '', 0);
      addReveal(article.querySelectorAll('.igari-tip'), 'left', 0);
      addReveal(article.querySelectorAll('.igari-product__cta-wrap'), '', 0);
      addReveal(article.querySelectorAll('.igari-closing .igari-shell > *'), '', 80);

      article.classList.add('igari-motion-ready');

      if (!('IntersectionObserver' in window)) {
        article.querySelectorAll('.igari-reveal').forEach(function (element) {
          element.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });

      article.querySelectorAll('.igari-reveal').forEach(function (element) {
        observer.observe(element);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initIgariMotion(document); });
  } else {
    initIgariMotion(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initIgariMotion(event.target);
  });
})();
